import { cloneElement, forwardRef, isValidElement, ReactElement } from 'react';

import { getRouterServiceSingleton } from './RouterService';
import { RouteLinkProps } from './types';
import { useRouterLinkResolver } from './useRouterLinkResolver';

/**
 * Retourne le composant permettant de naviguer
 */
export const RouteLink = forwardRef<HTMLAnchorElement, RouteLinkProps>(
  function RouteLink({ children, disabled = false, ...rest }, ref) {
    const SingletonRouteLink = getRouterServiceSingleton().RouteLink;
    const { routerLinkResolver } = useRouterLinkResolver();

    const linkProps = routerLinkResolver(rest);

    if (!linkProps?.href || disabled) {
      return <>{children}</>;
    }

    return (
      <SingletonRouteLink ref={ref} {...rest} {...linkProps}>
        {isValidElement(children)
          ? cloneElement(children as ReactElement<Record<string, unknown>>, {
              draggable: false,
              style: { userSelect: 'none', WebkitUserDrag: 'none' },
            })
          : children}
      </SingletonRouteLink>
    );
  }
);
